import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SelectedClient {
  id: string;
  publicId?: string;
  email: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  applicationType?: string;
  fullName: string;
}

interface SelectedClientState {
  selectedClient: SelectedClient | null;
  setSelectedClient: (client: SelectedClient) => void;
  clearSelectedClient: () => void;
}

export const useSelectedClientStore = create<SelectedClientState>()(
  persist(
    (set) => ({
      selectedClient: null,
      setSelectedClient: (client) => set({ selectedClient: client }),
      clearSelectedClient: () => set({ selectedClient: null }),
    }),
    {
      name: 'admin-selected-client',
    }
  )
);
